import React from 'react';
import Icon from '@sabre/spark-react-core/icon';
import { array, arrayOf, string } from 'prop-types';
import { CSVLink } from 'react-csv';
import { exportData } from './data-export-util.js';

const DataExport = ({
   data,
   groupedKeys,
   headers,
   isStackedData,
   type,
   fileName,
}) => {
   return (
      <div className='data-export-container'>
         <CSVLink
            data={exportData(data, groupedKeys, isStackedData)}
            headers={headers}
            filename={fileName}
         >
            {type === 'icon' ? (
               <Icon name='file-download' label='Download-data' style='line' />
            ) : (
               'Download'
            )}
         </CSVLink>
      </div>
   );
};

DataExport.propTypes = {
   data: arrayOf(array),
   groupedKeys: array,
   headers: arrayOf(array),
   type: string,
   fileName: string.isRequired,
};

export default DataExport;
